import styles from './result.module.scss';

const Result = ({ focused, handleClick, index, item, setFocused }) => {
    const { First_Name, Last_Name, Registration_Name, Gender } = item;
    const onMouseOver = () => {
        setFocused(index);
        highlight();
    };

    const highlight = () => {
        return focused === index ? styles.ResultActive : '';
    };

    return (
        <li className={styles.Result}>
            <button
                className={`${styles.ResultItem} ${highlight()}`}
                onClick={handleClick}
                onMouseOver={onMouseOver}
                onFocus={onMouseOver}
            >
                <div>
                    {First_Name} {Last_Name}
                </div>
                <div>
                    <span className={styles.gender}>{Gender}</span>
                    <span className={styles.hcpc_reg_name}>{Registration_Name}</span>
                </div>
            </button>
        </li>
    );
};

export default Result;
